import { memo, useCallback } from "react";
import { Product } from "../../../../interfaces/domain/menu";
import { ProductImage } from "../../../atoms";
import { PlateInfo } from "../PlateInfo";
import styles from "./MenuPlate.module.scss";
import { useNavigate } from "react-router-dom";
import { useOrdersStore, useUIStore } from "../../../../store";
import { getAssetUrl } from "../../../../utils/getAssetUrl";
import { useCartQuantity } from "../../../../hooks/useCartQuantity";

interface Props {
  plate: Product;
}

export const MenuPlate = memo(({ plate }: Props) => {
  const navigate = useNavigate();
  const setSection = useUIStore((s) => s.setSection);
  const config = useUIStore((s) => s.config);
  const src = getAssetUrl(plate.image_url, config);
  const canUseCart = useOrdersStore((s) => s.canUseCart);
  const quantityInCart = useCartQuantity(plate.id);

  const openModal = useCallback(() => {
    setSection("productModal");

    const params = new URLSearchParams(window.location.search);

    params.set("product", plate.id);
    params.set("title", plate.title ?? "");
    params.set("price", String(plate.price ?? ""));

    navigate(`?${params.toString()}`);
  }, [navigate, plate, setSection]);
  const hasImage = !!src;

  return (
    <article className={styles.cardMenuPlatePorDefecto} onClick={openModal}>
      <PlateInfo plate={plate} onOpenModal={openModal} />

      {hasImage ? (
        <ProductImage
          src={src}
          alt={plate.title}
          showPlaceholder={false}
          config={config}
          wrapperClassName={styles.space}
        />
      ) : (
        <div className={styles.space} />
      )}

      <button
        onClick={(e) => { e.stopPropagation(); openModal(); }}
        className={`${styles.addButton} ${hasImage ? styles.withImage : styles.noImage}`}
      >
        {canUseCart ? (
          quantityInCart > 0 ? (
            <span className={styles.quantity}>{quantityInCart}</span>
          ) : (
            <span className={styles.add}>+</span>
          )
        ) : (
          <span className={styles.viewmore}>Ver +</span>
        )}
      </button>
    </article>
  );
});

MenuPlate.displayName = "MenuPlate";

